import { EnumLikeableEntityType } from "src/components/common/buttons/like-button/like-button.types";
import { ICountry, ILanguage } from "src/consts/locale";
import { API_URL, createDynamicTrackingUrl } from "src/consts/urls";
import { useMutation } from "src/hooks/react-query/use-mutation";
import { useRouterLocale } from "src/utils/router/use-router-locale";
import { EnumActivityType } from "./generic-activity.api";

export const createAddLikeActivityUrl = (language: ILanguage, country: ICountry) => `${createDynamicTrackingUrl(language, country)}/addlikeactivity`;
export const API_LIKES_URL = `${API_URL}/likes`;

interface ILikesRequest {
    entityLikes: {
        entityId: string;
        entityType: EnumLikeableEntityType;
        liked: boolean;
    }[];
}

export interface IResponse {
    success: boolean;
}

export const useUpdateLikesMutation = () => {
    const { mutatePromise: updateLikes } = useMutation<IResponse, unknown, ILikesRequest>(API_LIKES_URL, {
        method: "PUT",
    });

    return updateLikes;
};

interface ILikeActivityRequest {
    activityType: EnumActivityType;
    parameter?: string;
}

export const useLikeActivityMutation = () => {
    const { language, country } = useRouterLocale();

    const { mutatePromise: likeActivity } = useMutation<void, void, ILikeActivityRequest>(createAddLikeActivityUrl(language, country));

    return likeActivity;
};
